const sdkUrlConfigOnline = {
  internal: {
    loginTrinitySDK: function (version) { // 实名统一登录SDK
      return {
        url: `//static.udache.com/common/trinity-login/${version}/login.min.js`,
        reg: /common\/trinity-login\/.*\/login.min.js/
      }
    },
    paySDK: function (version) {
      return {
        url: `//static.udache.com/public-biz/common-pay-js/version/${version}/pay.js`,
        reg: /public-biz\/common-pay-js\/.*\/pay.js/
      }
    }
  }
}

const sdkUrlConfigOffline = {
  internal: {
    loginTrinitySDK: function (version) { // 实名统一登录SDK
      return {
        url: 'http://passport.qatest.didichuxing.com/static/trinity-login/1.8.5/login.test.js',
        reg: /common\/trinity-login\/.*\/login.min.js/
      }
    },
    paySDK: function () {
      return {
        url: `//static.udache.com/public-biz/common-pay-js/version/0.6.9/pay.js`,
        reg: /public-biz\/common-pay-js\/.*\/pay.js/
      }
    }
  }

}

export function getSdkUrlCfg (isDev, lang, sdk, version) {
  let sdkUrlConfig = sdkUrlConfigOnline
  if (isDev) {
    sdkUrlConfig = sdkUrlConfigOffline
  }
  let sdkOpt
  let errorNameMap = {
    international: '国际',
    internal: '国内',
    brazil: '巴西',
    login4hktwSDK: '港台',
    login4AppointedSDK: '指定版本',
    loginTrinitySDK: '实名统一版本'
  }
  if (!sdkUrlConfig[lang][sdk]) {
    console.error('此' + (errorNameMap[lang] || lang) + '版本不支持' + (errorNameMap[sdk] || sdk) + '登录方式')
    return null
  }
  // 国内版独有指定版本和支持港台登录功能
  if (sdk === 'login4AppointedSDK' || sdk === 'loginTrinitySDK' || sdk === 'paySDK') {
    sdkOpt = sdkUrlConfig[lang][sdk](version)
  } else {
    sdkOpt = sdkUrlConfig[lang][sdk]
  }
  return sdkOpt
}
